import { useStaggerAnimation } from "@/hooks/useScrollAnimation";

export default function ContactSection() {
  const { ref, visibleItems } = useStaggerAnimation(4, { threshold: 0.15 });

  return (
    <section id="contact" className="py-16 bg-[#3ab5c6]">
      <div className="max-w-[1240px] mx-auto px-6">
        <div
          className="flex flex-col lg:flex-row items-center gap-10"
          ref={ref as React.RefObject<HTMLDivElement>}
        >
          {/* Title */}
          <div
            className="text-white lg:w-48 shrink-0"
            style={{
              opacity: visibleItems[0] ? 1 : 0,
              transform: visibleItems[0] ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.7s ease, transform 0.7s ease",
            }}
          >
            <p className="text-xs font-['Poppins'] tracking-widest opacity-80 mb-1">CONTACT</p>
            <h2 className="text-2xl font-bold leading-snug">
              お問い合わせ・<br />ご相談は<br />こちら
            </h2>
          </div>

          {/* Divider */}
          <div
            className="hidden lg:block w-px bg-white/30"
            style={{
              height: visibleItems[1] ? "96px" : "0px",
              transition: "height 0.6s ease 0.2s",
            }}
          ></div>

          {/* みりん Tel */}
          <div
            className="flex items-center gap-4 text-white"
            style={{
              opacity: visibleItems[1] ? 1 : 0,
              transform: visibleItems[1] ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.7s ease 0.15s, transform 0.7s ease 0.15s",
            }}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full border border-white/50">
              <i className="ri-phone-line text-xl"></i>
            </div>
            <div>
              <p className="text-xs opacity-80 mb-0.5">ヘルパーステーションみりん</p>
              <a
                href="tel:0566-68-6220"
                className="text-2xl font-bold font-['Poppins'] tracking-wider hover:opacity-80 transition-opacity cursor-pointer"
              >
                0566-68-6220
              </a>
              <p className="text-xs opacity-70 mt-0.5">FAX: 0566-68-6221</p>
            </div>
          </div>

          {/* Divider */}
          <div
            className="hidden lg:block w-px bg-white/30"
            style={{
              height: visibleItems[2] ? "96px" : "0px",
              transition: "height 0.6s ease 0.35s",
            }}
          ></div>

          {/* FD Tel */}
          <div
            className="flex items-center gap-4 text-white"
            style={{
              opacity: visibleItems[2] ? 1 : 0,
              transform: visibleItems[2] ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.7s ease 0.3s, transform 0.7s ease 0.3s",
            }}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full border border-white/50">
              <i className="ri-smartphone-line text-xl"></i>
            </div>
            <div>
              <p className="text-xs opacity-80 mb-0.5">株式会社FD（代表）</p>
              <a
                href="tel:080-6952-9336"
                className="text-2xl font-bold font-['Poppins'] tracking-wider hover:opacity-80 transition-opacity cursor-pointer"
              >
                080-6952-9336
              </a>
            </div>
          </div>

          {/* Divider */}
          <div
            className="hidden lg:block w-px bg-white/30"
            style={{
              height: visibleItems[3] ? "96px" : "0px",
              transition: "height 0.6s ease 0.5s",
            }}
          ></div>

          {/* Mail */}
          <div
            className="flex items-center gap-4 text-white"
            style={{
              opacity: visibleItems[3] ? 1 : 0,
              transform: visibleItems[3] ? "translateY(0)" : "translateY(30px)",
              transition: "opacity 0.7s ease 0.45s, transform 0.7s ease 0.45s",
            }}
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-full border border-white/50">
              <i className="ri-mail-line text-xl"></i>
            </div>
            <div>
              <p className="text-xs opacity-80 mb-2">メールでのお問い合わせ</p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 border border-white text-white text-sm px-5 py-2 rounded-full hover:bg-white hover:text-[#3ab5c6] transition-colors cursor-pointer whitespace-nowrap"
              >
                <span>›</span> メールフォームへ
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
